
export default {
  name: 'affiliator-ticket',
  props: {
    isAffiliatorLoaded: { type: Boolean, default: false },
    search: { type: Boolean, default: false },
    refund: { type: Boolean, default: false },
  },
};
